export const lt = {
  login: {
    heading: "Prisijungimas",
    email: "El. paštas",
    password: "Slaptažodis",
    emailPlaceholder: "jusu@pastas.lt",
    passwordPlaceholder: "Įveskite slaptažodį",
    signInButton: "Prisijungti",
    oauthButton: "Prisijungti su {provider}",
    divider: "arba",
    forgotPassword: "Pamiršote slaptažodį?",
    signUpPrompt: "Neturite paskyros?",
    signUpLink: "Registruotis",
  },
  signUp: {
    heading: "Registracija",
    email: "El. paštas",
    password: "Slaptažodis",
    confirmPassword: "Pakartokite slaptažodį",
    emailPlaceholder: "jusu@pastas.lt",
    passwordPlaceholder: "Sukurkite slaptažodį",
    confirmPasswordPlaceholder: "Pakartokite slaptažodį",
    signUpButton: "Registruotis",
    signInPrompt: "Jau turite paskyrą?",
    signInLink: "Prisijungti",
    checkEmailMessage:
      "Patikrinkite el. paštą – išsiuntėme patvirtinimo nuorodą.",
    backToSignIn: "Grįžti prie prisijungimo",
  },
  confirmSignUp: {
    heading: "Patvirtinkite el. paštą",
    email: "El. paštas",
    code: "Patvirtinimo kodas",
    emailPlaceholder: "jusu@pastas.lt",
    codePlaceholder: "Įveskite 6 skaitmenų kodą",
    confirmButton: "Patvirtinti",
    resendButton: "Siųsti kodą iš naujo",
    resendSuccess: "Naujas kodas išsiųstas į jūsų el. paštą.",
    backToSignIn: "Grįžti prie prisijungimo",
  },
  forgotPassword: {
    heading: "Pamirštas slaptažodis",
    email: "El. paštas",
    emailPlaceholder: "jusu@pastas.lt",
    sendCodeButton: "Siųsti patvirtinimo kodą",
    backToSignIn: "Grįžti prie prisijungimo",
  },
  resetPassword: {
    heading: "Naujas slaptažodis",
    email: "El. paštas",
    code: "Patvirtinimo kodas",
    newPassword: "Naujas slaptažodis",
    confirmPassword: "Pakartokite naują slaptažodį",
    emailPlaceholder: "jusu@pastas.lt",
    codePlaceholder: "Įveskite patvirtinimo kodą",
    newPasswordPlaceholder: "Įveskite naują slaptažodį",
    confirmPasswordPlaceholder: "Pakartokite naują slaptažodį",
    resetButton: "Nustatyti slaptažodį",
    backToSignIn: "Grįžti prie prisijungimo",
  },
  forceChangePassword: {
    heading: "Slaptažodžio keitimas",
    newPassword: "Naujas slaptažodis",
    confirmPassword: "Pakartokite naują slaptažodį",
    newPasswordPlaceholder: "Įveskite naują slaptažodį",
    confirmPasswordPlaceholder: "Pakartokite naują slaptažodį",
    changePasswordButton: "Pakeisti slaptažodį",
  },
  changePassword: {
    heading: "Slaptažodžio keitimas",
    oldPassword: "Dabartinis slaptažodis",
    newPassword: "Naujas slaptažodis",
    confirmPassword: "Pakartokite naują slaptažodį",
    oldPasswordPlaceholder: "Įveskite dabartinį slaptažodį",
    newPasswordPlaceholder: "Įveskite naują slaptažodį",
    confirmPasswordPlaceholder: "Pakartokite naują slaptažodį",
    changePasswordButton: "Pakeisti slaptažodį",
    successMessage: "Slaptažodis sėkmingai pakeistas.",
    back: "Atgal",
  },
  oauthCallback: {
    heading: "Prisijungimas",
    loading: "Jungiamės…",
    timeout: "Per ilgai? Grįžti atgal",
  },
  validation: {
    passwordsMismatch: "Slaptažodžiai nesutampa",
  },
  shared: {
    loadingButton: "Palaukite…",
    showPassword: "Rodyti slaptažodį",
    hidePassword: "Slėpti slaptažodį",
  },
};
